import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import _ from "lodash"
import { OverlayTrigger, PopOver } from "@tencent/spaui"

// 雇员所在团队信息
class TeamInfo extends React.Component {
  static propTypes = {
    userId: PropTypes.number,
    teamId: PropTypes.number,
    teamIds: PropTypes.arrayOf(PropTypes.number),
    teams: PropTypes.arrayOf(PropTypes.object),
  }

  componentDidMount() {
    const { webApi, teams } = this.props
    if (!teams) {
      webApi.getOrganizationTreeIfNeed().dispatch(ActionTypes.FETCH_ORGANIZATION_TREE)
    }
  }

  render() {
    const { teams, treeTeams, onlyShowLastLevel, triggerDisabled = false } = this.props
    let popover = null
    if (treeTeams instanceof Array) {
      popover = (
        <PopOver>
          {_.map(
            treeTeams.map((treeTeam, i) => {
              return (
                <React.Fragment key={i}>
                  {"/" + treeTeam.map((team) => team.name).join("/")}
                  <br />
                </React.Fragment>
              )
            })
          )}
        </PopOver>
      )
    }

    if (!popover) return null

    return (
      <OverlayTrigger trigger="hover" overlay={popover} placement="left" hideDelayTime={0} disabled={triggerDisabled} >
        <span className="UserInfo">
          {_.map(teams, (t, i) => (
            <React.Fragment key={i}>
              {t.name}
              <br />
            </React.Fragment>
          ))}
        </span>
      </OverlayTrigger>
    )
  }
}

function mapStateToProps(state, ownProps) {
  // 最后一级team，可能不止一个
  let teams = []
  // 优先使用userId
  if (ownProps.userId) {
    teams = state.organizationTree.tree && (_.filter(_.values(state.teamRepo), (t) => _.indexOf(t.employees, ownProps.userId) >= 0) || [])
  } else if (ownProps.teamId) {
    teams = state.organizationTree.tree && (_.filter(_.values(state.teamRepo), (t) => t.teamId === ownProps.teamId) || [])
  } else if (ownProps.teamIds) {
    teams = state.organizationTree.tree && (_.filter(_.values(state.teamRepo), (t) => _.includes(ownProps.teamIds, t.teamId)) || [])
  }
  // 将最后一级team转换为各级team的集合
  let treeTeams = null
  if (teams instanceof Array) {
    treeTeams = teams.map((team) => {
      const teamArray = []
      const findParent = (team) => {
        teamArray.unshift(team)
        let parent = state.teamRepo[team.parentId]
        if (parent) {
          findParent(parent)
        }
      }
      findParent(team)
      return teamArray
    })
  }

  return {
    teams: teams,
    treeTeams: treeTeams,
  }
}

export default withApi(connect(mapStateToProps)(TeamInfo))
